import {removeFromCookie} from './removeFromCookie';
import {COOKIES} from './cookies';

export const clearCookie = () => {
  removeFromCookie(COOKIES.PRODUCT_COOKIE_TOKEN);
  removeFromCookie(COOKIES.PRODUCT_COOKIE_COMPANY_ID);
};
